import * as React from "react";
import "./index.scss";
import { InputLabel } from "@mui/material";

const Textarea = ({
  value,
  onChange,
  placeholder,
  name,
  label,
  className,
  disabled,
  onBlur,
  isRequired = false,
  isError,
  maxLength
}) => {
  return (
    <div className={`input-container ${className}`}>
      {label && (
        <InputLabel className="label mb-2 fw-bold" htmlFor={name}>
          {label}{isRequired && <span className="star">*</span>}
        </InputLabel>
      )}
      <textarea
        className={`w-100 px-3 py-2 ${
          isError ? "error-input" : ""
        }`}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        id={name}
        disabled={disabled}
        onBlur={onBlur}
        maxLength={maxLength}
      />
    </div>
  );
};

export default Textarea;
